import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from 'app/components/shared.module';
import { VideoWidget, VideoWidgetComponent } from 'app/views/presentations/widgets/video/video.widget';

import { WidgetWrapperModule } from './../widgetWrapper.module';
import { ThumbnailHandler } from './thumbnailHandler';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        BrowserModule,
        SharedModule,
        WidgetWrapperModule.wrapWidget(VideoWidget)
    ],
    declarations: [
        VideoWidgetComponent
    ],
    entryComponents: [
        VideoWidgetComponent
    ],
    providers: [
        WidgetWrapperModule.wrapHandler(ThumbnailHandler)
    ]
})
export class VideoWidgetModule { }


// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/video/video.module.ts